import { render, staticRenderFns } from "./PvLogsTable.vue?vue&type=template&id=0a8548be&"
import script from "./PvLogsTable.vue?vue&type=script&lang=ts&"
export * from "./PvLogsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PvLogsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports